module.exports = __webpack_public_path__ + "static/img/hypnose-06.618a576.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hypnose-06.png
// module id = 100
// module chunks = 0